<template>
    <div style="display: flex; flex-direction: column;">
        <ModalHeader :is-show-back-btn="is_show_back_btn" title="임금 수령 동의서" />
        <div style="flex: 1;" v-if="!img_base64str && is_loaded">
            <iframe :src="'/view/wages_agreement_contents' + query" style="width:100%; height:100%; border:0px;" ref="agreement_contents_iframe"></iframe>
        </div>
        <div style="flex:1; overflow: auto;" v-else-if="is_loaded">
            <img :src="img_base64str" style="width:100%;">
        </div>
        <div style="padding:10px; border-top:1px solid #ddd;" v-if="mode === WAGES_AGREEMENT_MODE.INSERT" >
            <ProgressButton buttonText="제출" :showProgress="isSubmitting" @click="submit" style="margin-top:0px;" />
        </div>
    </div>
</template>

<script>
import ModalHeader from "@/components/common/ModalHeader";
import ProgressButton from "@/components/common/ProgressButton";
import ResponseCode from "../../ResponseCode";

export const WAGES_AGREEMENT_MODE = {
    VIEW : 0,
    INSERT : 1,
}

export default {
    name: "WagesAgreement",
    components: {
        ModalHeader, ProgressButton
    },
    props : {
        mode : {
            type : Number,
            default : WAGES_AGREEMENT_MODE.INSERT
        },
        completeAction : {
            type : Function,
            default : () => {}
        },
        agreement_info : {
            type : Object,
            default : () => {}
        },
        is_show_back_btn : {
            type : Boolean,
            default : true
        }
    },
    data() {
        return {
            WAGES_AGREEMENT_MODE : WAGES_AGREEMENT_MODE,
            isSubmitting: false,
            img_base64str : '',
            is_loaded : false,
            query : '',
        }
    },
    methods: {
        async getAgreement(){
            const parameters = {};

            const res = await this.$Axios.get('/api/agreement/wage', {params : parameters});
            if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
                return;
            }

            this.is_loaded = true;
            this.img_base64str = 'data:image/png;base64,' + res.data.image_data_str;
        },
        async submit() {
            const iframe_target = this.$refs.agreement_contents_iframe.contentDocument;
            const checkbox_arr_str = iframe_target.getElementById('checkbox_arr_str').value;

            const checkbox_arr = checkbox_arr_str.split(',');
            const scrollHeight = parseInt(checkbox_arr[1])

            if (checkbox_arr[0] != 'true') {
                this.$GlobalStore.showAlert('사인을 해주세요.');
                return;
            }

            /*eslint-disable no-undef */
            const canvas = await html2canvas(iframe_target.querySelector('#agreement_contents_print_wrap'), { 
                scale: 2,
                height: scrollHeight,
                windowHeight: scrollHeight,
                scrollX: 0,
                scrollY: 0,
            });

            this.isSubmitting = true;
            await this.completeAction(canvas.toDataURL('image/png').replace('data:image/png;base64,', ''))
            this.isSubmitting = false;
        }
    },
    created() {
        this.submit = this.$Once(this.submit);

        // this.title = '민감정보 동의 등록';
        if(this.mode === WAGES_AGREEMENT_MODE.VIEW){
            // this.title = '민감정보 동의 보기';
            this.getAgreement();
        } else {
            this.query = '?name=' + this.agreement_info.name + '&bank_name=' + this.agreement_info.bank_name + '&bank_account=' + this.agreement_info.bank_account;
            this.is_loaded = true;
        }
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
}


select {
    width: 100%;
    padding: 0px 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
    background-color: white;
    color: black;
}

button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 44px;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}
</style>